import React, { Component } from "react";

import '../../style/category.css';
import '../../style/generic.css';
import HeroSectionCategory from "../Herosection/HeroSectionCategory.js";
import {  Link, useParams } from "react-router";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Protagonisti from "./protagonisti.js";
import CardThree from "../cards/cardThree.js";
import CardTwo from "../cards/cardTwo.js";
import YoutubeClass from "../youtube/youtube.js";


class ProtagonistaDetail extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      personaggio: {},
      correlati:[],
      "page":1,
      "lastpage":1,
      }
      this.caricaAltriVideo = this.caricaAltriVideo.bind(this);
}

  componentDidMount() {
    this.fetchVideo(this.props.params.id,1);
  }


  fetchVideo(id,page) {
    const api = Constanti.url_Backend + "personaggio";
    axios.post(api, { idPersonaggio: id, page})
      .then(res => {
        const pers = res.data.data.personaggio;
        const videog = res.data.data.videogallery
         this.setState(prev => ({
          personaggio: pers,
          correlati:  videog.data,
          page: page,
          lastpage: videog.last_page
          }));
      
      })
      .catch(err => console.error(err));
  }

 altriVideo(id,page) {
    const api = Constanti.url_Backend + "personaggio";
    axios.post(api, { idPersonaggio: id, page})
      .then(res => {
        const pers = res.data.data.personaggio;
        const videog = res.data.data.videogallery
         this.setState(prev => ({
          personaggio: pers,
          correlati: [...(prev.correlati || []), ...videog.data],
          page: page,
          lastpage: videog.last_page
          }));
      
      })
      .catch(err => console.error(err));
  }

  caricaAltriVideo() {
    this.altriVideo(this.props.params.id, this.state.page + 1);
  }


  render(){
    const {personaggio,correlati,page,lastpage} = this.state;
    return (
    <>
  <section className="heroSectionPersonaggio margin-top-">
  <div className="flex vertical padding-top-131">
    <div className=""> <img src={Constanti.url_img_new+personaggio.foto} alt="protagonista" className="avatarDetail"></img></div>
    <div className="padding-top-40"> <span className="namePersonaggio namePersonaggioDetail">{personaggio.nome} {personaggio.cognome}</span></div>
  </div>
  </section>
  <section className="categoryDetail border-bottom">
  <div className="container padding-top-48">
  <div className="padding-bottom-16 padding-top-80 align-left ">Tutti i video</div>
 <div className="grid padding-bottom-80">
    {correlati != null && correlati.length>0 && correlati?.map(el => (
      <div className="contenitoreCard" key={el.id}>
            <Link to={'/video/'+el.id}>
    <CardTwo thumbnail={el.thumbnail} title={el.title} data={el.created_at} isCat="true"></CardTwo>
     </Link>
    </div>
    ))}
  </div>
  { page < lastpage &&
  <div className="carica-altri padding-top-48 padding-bottom-48 ">
     <div onClick={this.caricaAltriVideo} className="caricaAltri button secondary small w-button">Carica altri</div>
  </div>
  }
  </div>
 </section>
</>
    )
}
}

export default (props) => (
  <ProtagonistaDetail
      {...props}
      params={useParams()}
  />);